/**
 * Permission metadata aligned with legacy AclModel::getConfig().
 * Keep in sync with crm_atlas_backend/utils/aclPermissionCatalog.js
 */
export const ACL_LEVELS = [
  { name: "App", value: "app" },
  { name: "Client", value: "client" },
];

export const PERMISSION_CATALOG = [
  {
    value: "system",
    name: "System",
    description: "Access the System section",
    category: "General",
    levels: ["app"],
  },
  {
    value: "admin",
    name: "Admin",
    description:
      'Access the "Admin" section: Includes Accounts, Settings, Messages etc.',
    category: "General",
    levels: ["app"],
  },
  {
    value: "employeecandidate",
    name: "Temp Staff",
    description: "",
    category: "Personnel",
    levels: ["app"],
  },
  {
    value: "officememployee",
    name: "Office Staff",
    description: "",
    category: "Personnel",
    levels: ["app"],
  },
  {
    value: "client",
    name: "Clients",
    description: "",
    category: "Clients",
    levels: ["app"],
  },
  {
    value: "preferences",
    name: "Preferences",
    description:
      'All users with "Clients" permission can add a new client staff preference, but only those with "Write Preferences" can edit or remove them.',
    category: "Clients",
    levels: ["app"],
  },
  {
    value: "jobsupervisor",
    name: "Timesheet Signoff",
    description: "Access to sign off on timesheets.",
    category: "Clients",
    levels: ["client"],
  },
  {
    value: "signoffmanager",
    name: "Timesheet Signoff Manager",
    description: "",
    category: "Clients",
    levels: ["client"],
  },
  {
    value: "accounting",
    name: "Accounting",
    description: "Access to Accounting section.",
    category: "Management",
    levels: ["app"],
  },
  {
    value: "shift",
    name: "Shifts",
    description: "",
    category: "Jobs",
    levels: ["app"],
  },
  {
    value: "shiftactual",
    name: "Shift Actuals",
    description: "",
    category: "Jobs",
    levels: ["app"],
  },
];

const CATALOG_BY_VALUE = new Map(
  PERMISSION_CATALOG.map((entry) => [entry.value, entry]),
);

export function getPermissionMeta(value) {
  const key = String(value || "").trim();
  const entry = CATALOG_BY_VALUE.get(key);
  if (entry) {
    return {
      value: entry.value,
      name: entry.name,
      description: entry.description || "",
      category: entry.category || "",
    };
  }
  return {
    value: key,
    name: key,
    description: "",
    category: "",
  };
}

export function enrichPermissions(rows = []) {
  return rows.map((row) => {
    const permissionKey = row.permission ?? row.value;
    const meta = getPermissionMeta(permissionKey);
    return {
      value: meta.value,
      name: row.name || meta.name,
      description: meta.description,
      access: Number(row.access) || 0,
    };
  });
}
